import { render, staticRenderFns } from "./CardsProductsVinil.vue?vue&type=template&id=421d5c66&scoped=true&"
import script from "./CardsProductsVinil.vue?vue&type=script&lang=js&"
export * from "./CardsProductsVinil.vue?vue&type=script&lang=js&"
import style0 from "./CardsProductsVinil.vue?vue&type=style&index=0&id=421d5c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421d5c66",
  null
  
)

export default component.exports